<!--  -->
<template>
  <div class="">
    <div style="width: 100%">
      <el-page-header style="margin:20px" @back="goBack" 
      :content="formType == '' ? '我的费用':'费用详情'">
      </el-page-header>
      <div style="width: 963px; margin: 30px auto;display:flex">
        <!-- <div @click="goBack" style="cursor: pointer;width: 60px; margin: 35px 0;">
          <i class="el-icon-arrow-left"></i> <span>返回</span>
        </div> -->
        
        <el-card style="width: 963px; margin: 30px auto">
          <span
            style="
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: bold;
              color: #343434;
              margin-bottom: 20px;
            "
          >
            应付金额：{{ price }} CNY
          </span>
          <!-- 微信支付 -->
          <div
            class="myCursor"
            @click="Onchange('click', 'B')"
            style="margin-top: 30px; padding: 0 10px"
          >
            <div
              :class="[payType == 'B' ? 'myCard' : '']"
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <div style="display: flex; align-items: center">
                <img
                  style="margin-right: 10px"
                  src="./../../../assets/wechat.png"
                  alt=""
                />
                <span
                  style="
                    font-size: 18px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #343434;
                  "
                  >微信支付</span
                >
              </div>
              <el-checkbox
                @change="Onchange($event, 'B')"
                style="zoom: 150%"
                v-model="payWay[0].checked"
              ></el-checkbox>
            </div>
          </div>
          <!-- 支付宝支付 -->
          <div
            class="myCursor"
            @click="Onchange('click', 'A')"
            style="margin-top: 30px; padding: 0 10px"
          >
            <div
              :class="[[payType == 'A' ? 'myCard' : '']]"
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <div style="display: flex; align-items: center">
                <img
                  style="margin-right: 10px"
                  src="./../../../assets/ali.png"
                  alt=""
                />
                <span
                  style="
                    font-size: 18px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #343434;
                  "
                  >支付宝支付</span
                >
              </div>
              <el-checkbox
                @change="Onchange($event, 'A')"
                style="zoom: 150%"
                v-model="payWay[1].checked"
              ></el-checkbox>
            </div>
          </div>

          <el-button @click="payQuest" type="primary" style="margin: 30px 10px">
            <span style="padding: 0 30px"> 立即支付 </span>
          </el-button>
        </el-card>
      </div>

      <el-dialog
      :before-close="handleClose"
        :title="payType == 'B' ? '微信支付':'支付宝支付'"
        :visible.sync="dialogVisible"
        width="30%"
        center
      >
        <div style="display: flex">
          <qrcode
            style="margin: 0 auto"
            :wid="270"
            :hei="270"
            :imgwid="70"
            :imghei="70"
            :url="url"
          ></qrcode>
          <!-- iconurl="url" -->
        </div>
        <div style="text-align: center;margin-top:30px;font-size:18px">
          支付剩余时间 {{ countDonwM }}分 {{ countDonwS }}秒
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import qrcode from "vue_qrcodes";
export default {
  //import引入的组件需要注入到对象中才能使用

  components: {
    qrcode,
  },
  data() {
    //这里存放数据
    return {
      gobalCheck:false,
      tiemrCheckStatus:'',
      timer: "",
      countDonwS: 0,
      countDonwM: 0,
      price: "0",
      url:'',
      // url: "http://www.ff-zone.com.cn/erps/m/bill/billpay.jsp?bill_no=BL202010160045&qrcode_version=1&check_code=613663E1FCCB8181DD132B5781E35678",
      arapIdList: [],
      dialogVisible: false,
      payWay: [
        {
          ali: "A",
          checked: false,
        },
        {
          wechat: "B",
          checked: false,
        },
      ],
      payType: "",
      currentType: "",
      // 倒计时
      mins: 1 * 30,
      checkId:'',
      test:'',
      formType:'',
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            this.dialogVisible = false
            clearTimeout(this.timer);
            clearInterval(this.tiemrCheckStatus)
          })
          .catch(_ => {});
      },
    goBack() {
      this.$router.go(-1);
    },
    // 倒计时
    setDb(num) {
      //补零操作
      if (num < 10) {
        return "0" + num;
      } else {
        return "" + num;
      }
    },
    startCountTime() {
      this.runBack(this.mins);
    },
    setTime(num) {
      var sec = this.setDb(num % 60); //06 秒
      var min = this.setDb(Math.floor(num / 60) % 60); //Math.floor(num / 60) % 60     分
      return {
        secs: sec,
        mins: min,
      };
    },
    // 清除检查支付状态
    runBack(cm) {
      this.countDonwS = this.setTime(cm).secs;
      this.countDonwM = this.setTime(cm).mins;
      if (cm <= 0) {
        clearTimeout(this.timer);
        // 清除检查支付状态
        clearInterval(this.tiemrCheckStatus)
        this.$message.info("时间已到请...");
        this.dialogVisible = false;
        return;
      }
      this.timer = setTimeout(() => {
        cm -= 1;
        this.runBack(cm);
      }, 1000);
    },
    // 倒计时end
    payQuest() {

          // this.tiemrCheckStatus = setInterval(() => {
          //   let i = this.checkPayStatus(18941878500)
          //   // debugger
          //     console.log(i)
          //       if (this.checkPayStatus(18941878500)) {
          //         // console.log(this.checkPayStatus(res.data.data.id))
          //         this.dialogVisible = false;
          //         this.$message.success("支付成功,正在跳转...");
          //         setTimeout(() => {
          //           this.$router.go(-1);
          //         }, 2000);
          //       }
          //   }, 800);
          //   return
      clearTimeout(this.timer);
      if (this.arapIdList.length == 0) {
        this.$message.info("请先选择单号");
        return;
      }
      if (!this.payType) {
        this.$message.info("请先选择支付方式");
        return;
      }
     


    //  this.dialogVisible = true
      
      if(this.url){
        
           //  消除定时器
     clearTimeout(this.timer);
        // 清除检查支付状态
    clearInterval(this.tiemrCheckStatus)
    this.dialogVisible = true
        this.startCountTime();
         //  拿到id去轮询
            this.tiemrCheckStatus = setInterval(() => {
                 this.checkPayStatus(this.checkId)
                if (this.gobalCheck) {
                  this.dialogVisible = false;
                  clearInterval(this.tiemrCheckStatus)
                  this.$message.success("支付成功,正在跳转..");
                  setTimeout(() => {
                    this.$router.go(-1);
                  }, 2000);
                }
            }, 800);
        return
      }
      //  拿到id去轮询
      //  this.url ='21312'
      // console.log(this.checkPayStatus('322'))
      // this.dialogVisible = false
      //  this.$message.success('支付成功,正在跳转...')
      // setTimeout(() => {
      //     this.$router.go(-1)
      // }, 2000);
      // 超过5分钟秒视为失败,清除俩个timer 跳转
      // setTimeout(() => {
      //     this.$router.go(-1)
      // }, 60000);
      // return

      // 18940236800
      
    // formType有就代表从详情来的
    if(this.formType){
      this.payByBill()
    }else{
        this.axios
        .post("/arap/createFinaBillByFeeToPay", {
          arapIdList: this.arapIdList,
          payType: this.payType,
        })
        .then((res) => {
          
          if (res.data.code == 200) {
            this.startCountTime();
            this.url = res.data.data.url;
            this.dialogVisible = true;
            this.checkId = res.data.data.id
            //  拿到id去轮询
            this.tiemrCheckStatus = setInterval(() => {
              console.log(this.checkPayStatus(res.data.data.id))
              this.checkPayStatus(res.data.data.id)
                if (this.gobalCheck) {

                  console.log(this.checkPayStatus(res.data.data.id))
                  this.dialogVisible = false;
                  clearInterval(this.tiemrCheckStatus)
                  this.$message.success("支付成功,正在跳转...");
                  setTimeout(() => {
                    this.$router.go(-1);
                  }, 2000);
                }
            }, 800);
          
          } else {
            this.$message.info(res.data.message);
              //  消除定时器
     clearTimeout(this.timer);
        // 清除检查支付状态
    clearInterval(this.tiemrCheckStatus)
          }
        })
        .catch((res) => {
          this.$message.info(res.data.message || '服务器繁忙')
        });
    }
    },
     payByBill(){
       this.axios.get('/arap/payByBill/' + this.arapIdList[0] + '/' + this.payType).then(res =>{
               if (res.data.code == 200) {
                 this.startCountTime();
            this.url = res.data.data.url;
            this.dialogVisible = true;
            this.checkId = res.data.data.id
            //  拿到id去轮询
            this.tiemrCheckStatus = setInterval(() => {
              console.log(this.checkPayStatus(res.data.data.id))
              this.checkPayStatus(res.data.data.id)
                if (this.gobalCheck) {

                  console.log(this.checkPayStatus(res.data.data.id))
                  this.dialogVisible = false;
                  clearInterval(this.tiemrCheckStatus)
                  this.$message.success("支付成功,正在跳转...");
                  setTimeout(() => {
                    this.$router.go(-1);
                  }, 2000);
                }
            }, 800);
          
          } else {
            this.$message.info(res.data.message);
              //  消除定时器
     clearTimeout(this.timer);
        // 清除检查支付状态
    clearInterval(this.tiemrCheckStatus)
          }

       }).catch(res =>{
          this.$message.info(res.data.message || '服务器繁忙')
       })
     },
    // 检测支付状态
      checkPayStatus(id) {
      
      let flag = false;
    //  let res =  await 
      this.axios
        .get("/arap/getFinaBillPayStatus/" + id, {}).then((res) => {
             // debugger
        //   console.log(res.data.message);
          if (res.data.message == "1") {
            // debugger
            flag = true;
            this.gobalCheck = true
            // this.test = flag
            //   this.$message.success("支付成功,正在跳转axis...");
            //       setTimeout(() => {
            //         this.$router.go(-1);
            //       }, 2000);
            return flag;
          } else {
            flag = false;
            return flag;
          }
        // })
         
        })
        .catch((res) => {
          flag = false;
          console.log(res);
        });
      // return flag;
    },
      Onchange(e, index) {
      this.payWay.forEach((i) => {
        i.checked = false;
      });
      switch (index) {
        //   ali
        case "A":
          this.payType = "A";
          this.payWay[1].checked = true;
          break;
        // wechat
        case "B":
          this.payType = "B";
          this.payWay[0].checked = true;
          break;
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
  //  console.log(1);
  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    console.log(33333)
     //   多个支付的情况

    if (this.$route.params.id) {
      this.arapIdList.push(this.$route.params.id);
    }
    if (this.$route.params.temId) {
      this.$route.params.temId.forEach((i) => {
        this.arapIdList.push(i);
      });
    }
    if(this.$route.params.type){
    this.formType =   this.$route.params.type
    }
    this.price = this.$route.params.amount;
    console.log(this.$route);
    // console.log('mounted')
  },
  destroyed(){
     console.log('destroyed')
    //  消除定时器
     clearTimeout(this.timer);
        // 清除检查支付状态
    clearInterval(this.tiemrCheckStatus)
  },
};
</script>
<style scoped>
.myCard {
  padding: 0 20px;
  height: 80px;
  background: #ffffff;
  box-shadow: 0px 0px 16px 0px rgba(193, 193, 193, 0.27);
  border-radius: 10px;
}
.myCursor {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/PersonalCenter/billType/PayOrder.vue